import { matchPath, useHistory } from "react-router-dom";
import { SearchType } from "pages/private/adv-search-page/data";
import { Routes } from "routes";

const SEARCH_PAGES = [
	{ path: Routes.AdvSearchInfluensersPage, type: SearchType.InfluensersSearch },
	{ path: Routes.AdvSearchThreadsPage, type: SearchType.ThreadsSearch },
	{ path: Routes.AdvSearchGroupsPage, type: SearchType.GroupsSearch },
];

export const useSearchType = () => {
	const history = useHistory();

	let searchType: SearchType = SearchType.CoursesSearch;
	const isMatchPath = (path: string): boolean => !!matchPath(history.location.pathname, path);

	SEARCH_PAGES.forEach(({ path, type }) => {
		if (isMatchPath(path)) searchType = type;
	});

	return { searchType };
};
